module.exports = __webpack_public_path__ + "img/quotes.ab5f2da2.svg";